<template>
  <div class="c notifications">
    <div
      v-for="(notificationItem, index) in notifications"
      :id="`notify-${JSON.stringify(notificationItem)}`"
      :key="JSON.stringify(notificationItem)"
      class="c notification"
      :class="className(notificationItem)"
    >
      <span v-if="notificationItem" @click="goToDisorderArea(notificationItem.areaId)">
        {{ notificationItem.msg }}
      </span>
      <v-btn icon @click="closeNotification(index)">
        <v-icon>close</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Notification',

  computed: {
    notification() {
      return this.$store.state.notification.currentNotification;
    },
    notifications() {
      return this.$store.state.notification.notifications;
    },
  },

  methods: {
    closeNotification(index) {
      this.$store.state.notification.notifications.splice(index, 1);
    },
    className(notification) {
      let className;

      if (notification !== null) {
        if (notification.open) {
          className = `${className} is-open`;
        }
        if (notification.color) {
          className = `${className} is-${notification.color}`;
        }
        if (notification.hasCloseButton) {
          className = `${className} has-button`;
        }
        if (notification.className) {
          className = `${className} ${notification.className}`;
        }
      }

      if (notification.autoClose) {
        setTimeout(() => {
          notification.open = false;
        }, notification.autoClose);
      }

      return className;
    },
    goToDisorderArea(areaId) {
      this.$router.push(`/area/${areaId}`);
    },
  },
};
</script>
